import React from 'react'
import PropTypes from 'prop-types'
import withLayout from '../../../layout/withLayout'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import Input from '../../../form/component/Input'

const Barcode = ({ barcode, changeBarCode, onBarCodeEnter }) => {
    return (
        <ContentBox title="Barcode">

            <Row>
                <Column size={4}>
                    <Input
                        name="value"
                        object={barcode}
                        placeholder="Scanner"
                        onEnter={onBarCodeEnter}
                        onChange={changeBarCode}/>
                </Column>
                <Column size={8}/>
            </Row>

        </ContentBox>
    )
}


Barcode.propTypes = {
    barcode: PropTypes.object.isRequired,
    changeBarCode: PropTypes.func.isRequired,
    onBarCodeEnter: PropTypes.func.isRequired,
}


export default withLayout(Barcode)



// WEBPACK FOOTER //
// ./src/modules/process/component/barcode/Barcode.js